import type { PreferenceNameToValue } from 'app/types/preferences';

export type NotificationVisibilityTarget = PreferenceNameToValue['pushNotificationsForNeedDisabledGroups'][number];

export function normalizeDisabledGroups(value: unknown): NotificationVisibilityTarget[] {
  return Array.isArray(value)
    ? value.filter(
        (entry): entry is NotificationVisibilityTarget =>
          typeof entry === 'object' &&
          entry !== null &&
          (entry as { type?: unknown }).type !== undefined &&
          ((entry as { type: unknown }).type === 'group' || (entry as { type: unknown }).type === 'address') &&
          typeof (entry as { id?: unknown }).id === 'string',
      )
    : [];
}

export function disabledGroupsEqual(value: unknown, disabledGroups: NotificationVisibilityTarget[]): boolean {
  const normalizedValue = normalizeDisabledGroups(value);

  return (
    Array.isArray(value) &&
    value.length === normalizedValue.length &&
    normalizedValue.length === disabledGroups.length &&
    normalizedValue.every((target, index) => {
      const disabledTarget = disabledGroups[index]!;
      return target.type === disabledTarget.type && target.id === disabledTarget.id;
    })
  );
}

export function reconcileDisabledGroups(
  disabledGroups: NotificationVisibilityTarget[],
  visibleGroups: NotificationVisibilityTarget[],
): NotificationVisibilityTarget[] {
  return disabledGroups.filter(
    (disabledGroup, index) =>
      disabledGroups.findIndex(
        (candidate) => candidate.type === disabledGroup.type && candidate.id === disabledGroup.id,
      ) === index &&
      visibleGroups.some(
        (visibleGroup) => visibleGroup.type === disabledGroup.type && visibleGroup.id === disabledGroup.id,
      ),
  );
}
